export default __webpack_public_path__ + "static/media/pantry1-afterH-480w.85dc01f6.webp";